import React, { useContext } from 'react';
import {
    GelBoxLayout,
    GelIcon,
    GelParagraph,
    GelTag
} from '@tal-gel/components';
import { getGelTokens } from '@tal-gel/theming';
import { UserContext } from '../../common/usercontext/user.context';

const DigiCorroBadge = () => {
    const {global: {sizeBaseUnit, sizeNone, sizeBaseX2, themeColorTextDark, sizeBaseX3}, tags: {tagWarningIconColor}} = getGelTokens()

    const { contextData } = useContext(UserContext);

    if (contextData.memberDetails?.unReadDigiCorroMessageCount == 0) {
        return null;
    }

    return (
        <span style={{ 
            marginRight: `${sizeBaseUnit * 2}px`, 
            paddingBottom: `${sizeBaseUnit}px`,
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'end',
             }}>
            <GelTag small warning>
                <GelBoxLayout
                    distribution='center'
                    alignment='center'
                    space={[0.5, 10]}
                    style={{
                        gap: `${sizeBaseUnit}px`,
                        paddingLeft: `${sizeBaseX2}px`,
                        paddingRight: `${sizeBaseX2}px`,
                        cursor: 'pointer'
                    }}
                    childStyle={{
                        paddingLeft: `${sizeNone}px`,
                        paddingRight: `${sizeNone}px`
                    }}>
                    <GelIcon
                        name="Notification"
                        width={sizeBaseUnit * 4}
                        color={tagWarningIconColor}
                    />
                    <GelParagraph style={{ fontSize: sizeBaseX3, paddingRight: sizeBaseUnit, color: themeColorTextDark }}>{contextData.memberDetails?.unReadDigiCorroMessageCount}</GelParagraph>
                </GelBoxLayout>
            </GelTag>
        </span>
    );

}

export default DigiCorroBadge;